<template>
  <div id="platform-settings">
    <!-- Spinner global -->
    <pui-common-spinner
      v-show="isLoading"
      :message="loadingMessage"
      fullscreen
      hideBackgroundCircle
    />
    <div class="settings-content-wrapper">
      <div class="settings-actionBar" v-if="isMaintenanceActive">
        <pui-alert type="error">
          <div>{{ $t('admin.platform.maintenance.is_active') }}</div>
        </pui-alert>
      </div>
      <div class="settings-content">
        <h1 class="settings-title">
          {{ $t('admin.platform.maintenance.title') }}
        </h1>
        <div class="settings-block-content">
          <div @click.prevent="openMaintenanceDialog">
            <pui-switcher
              v-model="isMaintenanceActive"
              :label="$t('admin.platform.maintenance.toggle_maintenance.label')"
            />
          </div>
          <!-- Message de maintenance -->
          <pui-input
            v-model="maintenanceMessage"
            :showLabel="true"
            :placeholder="$t('admin.platform.maintenance.message.placeholder')"
            :label="$t('admin.platform.maintenance.message.label')"
            name="maintenanceMessage"
            type="text"
            class="maintenance-message"
          />
        </div>
      </div>
    </div>
    <!-- Pop-up de validation -->
    <pui-dialog ref="confirmMaintenanceDialog" :showCloseButton="false" transition="slide-up">
      <h3 class="message">
        <span class="mdi mdi-power" />
        {{ modalMaintenanceMessage }}
      </h3>
      <pui-button-list>
        <pui-button
          :outline="true"
          @click="cancelMaintenance"
          variant="secondary"
          picto="mdi-close"
        >
          {{ $t('admin.platform.maintenance.confirmation.cancel') }}
        </pui-button>
        <pui-button
          :outline="false"
          @click="confirmMaintenance"
          variant="secondary"
          picto="mdi-power"
        >
          {{ $t('admin.platform.maintenance.confirmation.confirm') }}
        </pui-button>
      </pui-button-list>
    </pui-dialog>
  </div>
</template>
<script>
import services from '../../../core/services';
import { getAdminService } from '../services';

export default {
  data() {
    return {
      isMaintenanceActive: false,
      maintenanceMessage: '',
      isLoading: false,
      loadingMessage: '',
    };
  },
  computed: {
    /**
     * Maintenance modal message.
     */
    modalMaintenanceMessage() {
      return this.isMaintenanceActive !== true
        ? this.$t('admin.platform.maintenance.confirmation.enable_maintenance')
        : this.$t('admin.platform.maintenance.confirmation.disable_maintenance');
    },
  },
  methods: {
    /**
     * Start global loading (global spinner).
     * @param message : Loading message
     */
    startLoading(message) {
      this.loadingMessage = message;
      this.isLoading = true;
    },
    /**
     * Stop global loading.
     */
    stopLoading() {
      this.isLoading = false;
    },
    /**
     * Confirm maintenance dialog.
     */
    async confirmMaintenance() {
      // Update maintenance flag
      this.isMaintenanceActive = !this.isMaintenanceActive;

      // Turn maintenance on or off
      this.startLoading();
      this.$refs.confirmMaintenanceDialog.close();

      try {
        if (this.isMaintenanceActive === true) {
          await getAdminService('maintenanceService').turnSiteOffline(this.maintenanceMessage);
        } else {
          await getAdminService('maintenanceService').turnSiteOnline();
        }
        services
          .getService('alerts')
          .alertSuccess(this.$t('admin.platform.maintenance.save_success'));
      } catch (err) {
        // Cancel maintenance flag update
        this.isMaintenanceActive = !this.isMaintenanceActive;
      }
      this.stopLoading();
    },
    /**
     * Cancel maintenance confirmation dialog.
     */
    cancelMaintenance() {
      this.$refs.confirmMaintenanceDialog.close();
    },
    /**
     * Open maintenance confirmation dialog.
     */
    openMaintenanceDialog() {
      this.$refs.confirmMaintenanceDialog.open();
    },
  },
  /**
   * Mounted hook.
   */
  async mounted() {
    this.startLoading();

    try {
      const maintenanceInformations = await getAdminService(
        'maintenanceService'
      ).getMaintenanceInformation();
      if (maintenanceInformations != null) {
        this.isMaintenanceActive = maintenanceInformations.isOffline;
        this.maintenanceMessage = maintenanceInformations.offlineMessage;
      }
    } catch (err) {
      // Do nothing
    }

    this.stopLoading();
  },
};
</script>
